'use client';

import {
  selectCartSummary,
  selectIsCheckoutDetailsLoaded,
  selectCommerceItems,
  selectClosenessQualifiers,
} from '@next-app/lib/features/checkout/CheckoutSelector';
import Conditional from '@next-app/components/Conditional';
import SkeletonUI from '@next-app/components/Skeleton/Skeleton';
import PromoCode from '@next-app/components/shared/PromoCode/PromoCode';
import { useSelector } from 'react-redux';
import { triggerCheckoutFormErrorEvent } from '@next-app/utils/CheckoutHelper';
import {
  selectIsFurniture,
  selectLlmAPIVersion,
} from '@next-app/lib/features/InitSelectors';
import { useEffect } from 'react';
import parse from 'html-react-parser';
import { extractText } from '@next-app/utils/common-utils';

const PromotionalCode = () => {
  /**
   *  Selectors
   */
  const isCheckoutDetailsLoaded = useSelector(selectIsCheckoutDetailsLoaded);
  const cartSummary = useSelector(selectCartSummary);
  const commerceItems = useSelector(selectCommerceItems);
  const closenessQualifiers = useSelector(selectClosenessQualifiers);
  const llmAPIVersion = useSelector(selectLlmAPIVersion);
  const isFurniture = useSelector(selectIsFurniture);

  useEffect(() => {
    if (isCheckoutDetailsLoaded && closenessQualifiers?.length > 0) {
      const errorMessage = extractText(parse(closenessQualifiers?.[0]?.name));
      triggerCheckoutFormErrorEvent({
        step: 'applyPromoCode',
        llmAPIVersion,
        isFurniture,
        errors: [
          {
            localizedMessage: errorMessage,
            errorCode: 'qualifierMessage',
            propertyPath: 'qualifierMessage',
          },
        ],
        fieldName: 'qualifierMessage',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [closenessQualifiers]);

  return (
    <>
      <Conditional if={!isCheckoutDetailsLoaded}>
        <SkeletonUI width={'100%'} height={30} />
      </Conditional>
      <Conditional if={isCheckoutDetailsLoaded}>
        <PromoCode
          pageType={'checkout'}
          cartSummary={cartSummary}
          commerceItems={commerceItems}
        />
      </Conditional>
    </>
  );
};

export default PromotionalCode;
